var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-14",attrs:{"id":"app"}},[_c('header-app'),_c('router-view',{staticClass:"grid-1 p-4 scroll-smooth light break-words"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }